module.exports = __webpack_public_path__ + "img/4.53010dec.png";